import { render, staticRenderFns } from "./DispensationItem.vue?vue&type=template&id=bca3706c"
import script from "./DispensationItem.vue?vue&type=script&lang=js"
export * from "./DispensationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports